import { observer } from 'mobx-react-lite'
import type { PowerDialerStatus } from 'entities/PowerDialer/api/types'
import type { IFilterValue, IWidgetProps } from 'widgets/FilterEditor/types/types'
import { WidgetStatus } from 'widgets/FilterEditor/ui/Widget/WidgetStatus'
import { powerDialerStatusBadgeConfig } from 'widgets/PowerDialer/lib/powerDialerStatusBadgeConfig'

export const WidgetPowerDialerStatus = observer(
  (props: IWidgetProps<IFilterValue<PowerDialerStatus>, PowerDialerStatus[]>) => {
    return (
      <WidgetStatus
        getConfigByStatus={(status) => powerDialerStatusBadgeConfig[status]}
        {...props}
      />
    )
  }
)
